import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54398a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Plan-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Для использования условия равномерной погрузки, остальные условия должны быть сняты. ", -1))
const _hoisted_3 = { class: "container-fluid px-0" }
const _hoisted_4 = { class: "Plan-padding" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "План")
], -1))
const _hoisted_7 = { class: "col-4 Plan-stateDesc" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Plan-switchText" }, "Скрыть настройки", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Plan-switchIcon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-up" })
], -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Plan-switchText" }, "Показать настройки", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Plan-switchIcon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" })
], -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "card Plan-mainSettings" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Основное", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Дата создания", -1))
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Дата расчета", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Тип оптимизации", -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "col-4 Plan-checkboxGroup" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Дополнительные ограничения", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Plan-TooltipText" }, " Равномерность погрузки пиломатериалов может быть рассчитана 3-мя способами: ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Plan-TooltipText" }, " 1. Если объём заказанных пиломатериалов может быть размещён контейнерах от 48м³ до 55м³, система постарается разместить все заказанные пиломатериалы в контейнерах. ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Plan-TooltipText" }, " 2. Если объём заказанных пиломатериалов размещается в количестве меньшем 48м³, система постарается равномерно недогрузить все контейнеры. ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Plan-TooltipText" }, " 3. Если вес заказанных пиломатериалов размещается в количестве большем 55м³, система постарается равномерно недогрузить пиломатериалы по всем заказам. ", -1))
const _hoisted_38 = { class: "col-4" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Данные", -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Настройки импорта пакетов ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Настройки импорта контейнеров ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Настройки импорта заказов ", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Настройки импорта отгрузок ", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, "Импорт")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, "Экспорт")
], -1))
const _hoisted_47 = {
  key: 0,
  class: "Changes-warning"
}
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-12" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, "Сохранить", -1))
const _hoisted_51 = { class: "col-12" }
const _hoisted_52 = { class: "card border-0" }
const _hoisted_53 = {
  class: "card-body",
  style: {"padding":"0 0 10px 0"}
}
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = { class: "d-inline-block" }
const _hoisted_56 = { class: "dx-button-text" }
const _hoisted_57 = {
  key: 0,
  class: "d-inline-block Plan-progressBarWrapper px-2"
}
const _hoisted_58 = { class: "progress" }
const _hoisted_59 = {
  class: "progress-bar progress-bar-striped progress-bar-animated",
  role: "progressbar",
  "aria-valuenow": "100",
  "aria-valuemin": "0",
  "aria-valuemax": "100",
  style: {"width":"100%","background-color":"#363b5d !important"}
}
const _hoisted_60 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_DateControl = _resolveComponent("DateControl")!
  const _component_EnumControl = _resolveComponent("EnumControl")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_DxTooltip = _resolveComponent("DxTooltip")!
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DxTabPanel = _resolveComponent("DxTabPanel")!
  const _component_ImportAllWorkflow = _resolveComponent("ImportAllWorkflow")!
  const _component_ExportAllWorkflow = _resolveComponent("ExportAllWorkflow")!
  const _component_PlanInnerInfoDialog = _resolveComponent("PlanInnerInfoDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxPopup, {
      visible: _ctx.popupVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.popupVisible) = $event)),
      "drag-enabled": true,
      "close-on-outside-click": false,
      "show-close-button": false,
      "show-title": true,
      width: 400,
      height: 220,
      shading: true,
      resizeEnabled: false,
      title: "Внимание"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_DxToolbarItem, {
          options: _ctx.okButtonOptions,
          widget: "dxButton",
          location: "after",
          toolbar: "bottom"
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          options: _ctx.cancelButtonOptions,
          widget: "dxButton",
          location: "after",
          toolbar: "bottom"
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, _toDisplayString(_ctx.stateDescription), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_DxButton, {
              class: "float-end",
              width: 36,
              type: "normal",
              icon: "info",
              hint: "Справка",
              "styling-mode": "contained",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onShowInfo($event)))
            })
          ])
        ]),
        _createElementVNode("div", {
          class: "Plan-switch",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSwitchChange && _ctx.onSwitchChange(...args))),
          "data-bs-toggle": "collapse",
          "data-bs-target": ".multi-collapse",
          "aria-expanded": "false",
          "aria-controls": "collapse1"
        }, [
          (_ctx.isSettingsOpen.shown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: _normalizeClass(["collapse multi-collapse", _ctx.showClass]),
              id: "collapse1"
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _hoisted_24,
                      _createVNode(_component_TextControl, {
                        class: "ModelField-control",
                        stylingMode: "outlined",
                        placeholder: "Наименование...",
                        "show-clear-button": true,
                        value: _ctx.model.name,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.name) = $event)),
                        hasEmptyValue: false,
                        onChanged: _ctx.haveChanges
                      }, null, 8, ["value", "onChanged"]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createVNode(_component_DateControl, {
                            class: "ModelField-control",
                            value: _ctx.model.creationDate,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.creationDate) = $event)),
                            mode: "datetime",
                            stylingMode: "outlined",
                            hasEmptyValue: false,
                            readOnly: true,
                            onChanged: _ctx.haveChanges
                          }, null, 8, ["value", "onChanged"])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createVNode(_component_DateControl, {
                            class: "ModelField-control",
                            value: _ctx.model.calcDate,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.calcDate) = $event)),
                            mode: "datetime",
                            stylingMode: "outlined",
                            hasEmptyValue: false,
                            readOnly: true,
                            onChanged: _ctx.haveChanges
                          }, null, 8, ["value", "onChanged"])
                        ])
                      ]),
                      _hoisted_30,
                      _createVNode(_component_EnumControl, {
                        class: "ModelField-control",
                        id: _ctx.model.optimizationType,
                        "onUpdate:id": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.optimizationType) = $event)),
                        desc: _ctx.model.optimizationTypeDescription,
                        "onUpdate:desc": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.optimizationTypeDescription) = $event)),
                        enumType: "planOptimizationType",
                        stylingMode: "outlined",
                        onChanged: _ctx.haveChanges
                      }, null, 8, ["id", "desc", "onChanged"]),
                      (_ctx.calculationTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, " Время последнего расчета — " + _toDisplayString(_ctx.calculationTime) + ". ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", null, [
                        _createVNode(_component_DxCheckBox, {
                          class: "Plan-checkbox",
                          value: _ctx.model.forbidWholeHalfInOneContainer,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.forbidWholeHalfInOneContainer) = $event)),
                          text: "Запрет на погрузку в один контейнер пакетов разных типов",
                          onValueChanged: _ctx.haveChanges,
                          disabled: _ctx.checkboxDisabled
                        }, null, 8, ["value", "onValueChanged", "disabled"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_DxCheckBox, {
                          class: "Plan-checkbox",
                          value: 
                            _ctx.model.forbidDifferentLengthsInOneContainer
                          ,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((
                            _ctx.model.forbidDifferentLengthsInOneContainer
                          ) = $event)),
                          text: "Запрет на погрузку в один контейнер пакетов разных длин",
                          onValueChanged: _ctx.haveChanges,
                          disabled: _ctx.checkboxDisabled
                        }, null, 8, ["value", "onValueChanged", "disabled"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_DxCheckBox, {
                          class: "Plan-checkbox",
                          value: 
                            _ctx.model.forbidDifferentSpeciesInOneContainer
                          ,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((
                            _ctx.model.forbidDifferentSpeciesInOneContainer
                          ) = $event)),
                          text: "Запрет на погрузку в один контейнер пакетов разных пород",
                          onValueChanged: _ctx.haveChanges,
                          disabled: false
                        }, null, 8, ["value", "onValueChanged"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_DxCheckBox, {
                          class: "Plan-checkbox",
                          value: 
                            _ctx.model.forbidDifferentNomenclatureInOneContainer
                          ,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((
                            _ctx.model.forbidDifferentNomenclatureInOneContainer
                          ) = $event)),
                          text: "Запрет на погрузку в один контейнер пакетов разных номенклатур",
                          onValueChanged: _ctx.haveChanges,
                          disabled: _ctx.checkboxDisabled
                        }, null, 8, ["value", "onValueChanged", "disabled"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_DxCheckBox, {
                          class: "Plan-checkbox",
                          value: 
                            _ctx.model.forbidDifferentOrdersInOneContainer
                          ,
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((
                            _ctx.model.forbidDifferentOrdersInOneContainer
                          ) = $event)),
                          text: "Запрет на погрузку в один контейнер пакетов из разных заказов",
                          onValueChanged: _ctx.haveChanges,
                          disabled: _ctx.checkboxDisabled
                        }, null, 8, ["value", "onValueChanged", "disabled"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_DxCheckBox, {
                          class: "Plan-checkbox",
                          value: 
                            _ctx.model.forbidLoadingDifferentCutSizesInOneContainer
                          ,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((
                            _ctx.model.forbidLoadingDifferentCutSizesInOneContainer
                          ) = $event)),
                          text: "Запрет на погрузку в один контейнер пакетов разных сечений",
                          onValueChanged: _ctx.haveChanges,
                          disabled: _ctx.checkboxDisabled
                        }, null, 8, ["value", "onValueChanged", "disabled"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_DxCheckBox, {
                          class: "Plan-checkbox",
                          value: 
                            _ctx.model.forbidLoadingFromDifferentStoragePlaces
                          ,
                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((
                            _ctx.model.forbidLoadingFromDifferentStoragePlaces
                          ) = $event)),
                          text: "Запрет на погрузку в один контейнер из разных ячеек",
                          onValueChanged: _ctx.haveChanges,
                          disabled: _ctx.checkboxDisabled
                        }, null, 8, ["value", "onValueChanged", "disabled"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_DxCheckBox, {
                          class: "Plan-checkbox",
                          style: {"display":"inline-block"},
                          value: _ctx.model.isUniformLoading,
                          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.model.isUniformLoading) = $event)),
                          text: "Равномерная погрузка",
                          onValueChanged: _ctx.haveChanges
                        }, null, 8, ["value", "onValueChanged"]),
                        _createElementVNode("div", {
                          class: "Plan-InfoButton",
                          onMouseenter: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.toggleTooltip && _ctx.toggleTooltip(...args))),
                          onMouseleave: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.toggleTooltip && _ctx.toggleTooltip(...args)))
                        }, [
                          _createVNode(_component_DxButton, {
                            id: "info",
                            icon: "info"
                          }),
                          _createVNode(_component_DxTooltip, {
                            visible: _ctx.tooltipVisible,
                            "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.tooltipVisible) = $event)),
                            "hide-on-outside-click": false,
                            target: "#info"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_34,
                              _hoisted_35,
                              _hoisted_36,
                              _hoisted_37
                            ]),
                            _: 1
                          }, 8, ["visible"])
                        ], 32)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      (_ctx.isShowImportSettings)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _hoisted_41,
                            _createVNode(_component_CatalogueSelectControl, {
                              class: "ModelField-selectControl",
                              stylingMode: "outlined",
                              id: _ctx.model.planPackageImportSettingsId,
                              "onUpdate:id": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.model.planPackageImportSettingsId) = $event)),
                              desc: 
                            _ctx.model.planPackageImportSettingsDescription
                          ,
                              "onUpdate:desc": _cache[20] || (_cache[20] = ($event: any) => ((
                            _ctx.model.planPackageImportSettingsDescription
                          ) = $event)),
                              keyField: "id",
                              displayDescField: "name",
                              catalogueComponentName: "catalogues/ImportSettings/PlanPackageImportSettings/PlanPackageImportSettingsCatalogue",
                              hasEmptyValue: true,
                              onChanged: _ctx.haveChanges
                            }, null, 8, ["id", "desc", "onChanged"]),
                            _hoisted_42,
                            _createVNode(_component_CatalogueSelectControl, {
                              class: "ModelField-selectControl",
                              stylingMode: "outlined",
                              id: _ctx.model.planContainerImportSettingsId,
                              "onUpdate:id": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.model.planContainerImportSettingsId) = $event)),
                              desc: 
                            _ctx.model.planContainerImportSettingsDescription
                          ,
                              "onUpdate:desc": _cache[22] || (_cache[22] = ($event: any) => ((
                            _ctx.model.planContainerImportSettingsDescription
                          ) = $event)),
                              keyField: "id",
                              displayDescField: "name",
                              catalogueComponentName: "catalogues/ImportSettings/PlanContainerImportSettings/PlanContainerImportSettingsCatalogue",
                              hasEmptyValue: true,
                              onChanged: _ctx.haveChanges
                            }, null, 8, ["id", "desc", "onChanged"]),
                            _hoisted_43,
                            _createVNode(_component_CatalogueSelectControl, {
                              class: "ModelField-selectControl",
                              stylingMode: "outlined",
                              id: _ctx.model.planOrderImportSettingsId,
                              "onUpdate:id": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.model.planOrderImportSettingsId) = $event)),
                              desc: 
                            _ctx.model.planOrderImportSettingsDescription
                          ,
                              "onUpdate:desc": _cache[24] || (_cache[24] = ($event: any) => ((
                            _ctx.model.planOrderImportSettingsDescription
                          ) = $event)),
                              keyField: "id",
                              displayDescField: "name",
                              catalogueComponentName: "catalogues/ImportSettings/PlanOrderImportSettings/PlanOrderImportSettingsCatalogue",
                              hasEmptyValue: true,
                              onChanged: _ctx.haveChanges
                            }, null, 8, ["id", "desc", "onChanged"]),
                            _hoisted_44,
                            _createVNode(_component_CatalogueSelectControl, {
                              class: "ModelField-selectControl",
                              stylingMode: "outlined",
                              id: _ctx.model.planShipmentImportSettingsId,
                              "onUpdate:id": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.model.planShipmentImportSettingsId) = $event)),
                              desc: 
                            _ctx.model.planShipmentImportSettingsDescription
                          ,
                              "onUpdate:desc": _cache[26] || (_cache[26] = ($event: any) => ((
                            _ctx.model.planShipmentImportSettingsDescription
                          ) = $event)),
                              keyField: "id",
                              displayDescField: "name",
                              catalogueComponentName: "catalogues/ImportSettings/PlanShipmentImportSettings/PlanShipmentImportSettingsCatalogue",
                              hasEmptyValue: true,
                              onChanged: _ctx.haveChanges
                            }, null, 8, ["id", "desc", "onChanged"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createVNode(_component_DxButton, {
                          disabled: !_ctx.model.id,
                          class: "Plan-importButton",
                          type: "default",
                          onClick: _ctx.onImport,
                          "styling-mode": "outlined"
                        }, {
                          content: _withCtx(() => [
                            _hoisted_45
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"]),
                        _createVNode(_component_DxButton, {
                          disabled: !_ctx.model.id,
                          class: "Plan-exportButton",
                          style: {"margin-left":"10px"},
                          type: "default",
                          onClick: _ctx.onExport,
                          "styling-mode": "outlined"
                        }, {
                          content: _withCtx(() => [
                            _hoisted_46
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ])
                    ])
                  ]),
                  (_ctx.hasSettingsChanges)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, " Изменения вступят в силу после сохранения "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_DxButton, {
                        class: "Plan-saveButton",
                        type: "default",
                        disabled: _ctx.isCalculation,
                        onClick: _ctx.onSave,
                        "styling-mode": "outlined"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", null, [
                            (_ctx.saving)
                              ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                                  key: 0,
                                  icon: "circle-notch",
                                  spin: ""
                                }))
                              : _createCommentVNode("", true),
                            _hoisted_50
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ])
                  ])
                ])
              ])
            ], 2)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["row", { 'Plan-progressBarSticked': _ctx.isCalculation }])
        }, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_component_DxButton, {
                      class: "Plan-calcButton",
                      type: "default",
                      "styling-mode": "outlined",
                      disabled: _ctx.calcButtonDisabled,
                      onClick: _ctx.onCalcButtonClick
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("span", null, [
                          (_ctx.calculationStarting || _ctx.calculationStopping)
                            ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                                key: 0,
                                icon: "circle-notch",
                                spin: ""
                              }))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.calcButtonText), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  (_ctx.isCalculation)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, " Расчет - " + _toDisplayString(_ctx.time), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ], 2)
      ]),
      _createVNode(_component_DxTabPanel, {
        class: "Plan-panel",
        key: _ctx.tabsRenderKey,
        height: "100%",
        "data-source": _ctx.tabs,
        "selected-index": _ctx.selectedTabIndex,
        "onUpdate:selected-index": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
        loop: false,
        "animation-enabled": false,
        "swipe-enabled": false
      }, {
        title: _withCtx(({ data: tab }) => [
          _createElementVNode("span", null, _toDisplayString(tab.name), 1)
        ]),
        item: _withCtx(({ data: tab }) => [
          _createElementVNode("div", {
            id: tab.domId,
            class: "catalogue-panel"
          }, null, 8, _hoisted_60)
        ]),
        _: 1
      }, 8, ["data-source", "selected-index"])
    ]),
    _createVNode(_component_ImportAllWorkflow, {
      controller: "Plan",
      importConfig: _ctx.importConfig,
      planId: this.model.id,
      onImportExportClose: _ctx.onImportExportClose,
      ref: "importWorkflow"
    }, null, 8, ["importConfig", "planId", "onImportExportClose"]),
    _createVNode(_component_ExportAllWorkflow, {
      controller: "Plan",
      exportConfig: _ctx.exportConfig,
      ref: "exportWorkflow"
    }, null, 8, ["exportConfig"]),
    _createVNode(_component_PlanInnerInfoDialog, { ref: "infoDialog" }, null, 512)
  ]))
}